import { useSEO } from '../../utils/seo';
import Hero from './components/Hero';
import USPBlock from './components/USPBlock';
import PopularRoutes from './components/PopularRoutes';
import WhyChooseUs from './components/WhyChooseUs';
import BookingCTA from './components/BookingCTA';
import SEOContent from './components/SEOContent';
import Footer from './components/Footer';
import PriceCalculator from './components/PriceCalculator';

export default function Home() {
  useSEO({
    title: 'Airport Taxi Utrecht | 24/7 Service & Vaste Prijs',
    description: 'Airport taxi vanuit Utrecht naar Schiphol, Eindhoven, Rotterdam of Brussels. 24/7 beschikbaar, vaste prijs mogelijk. Direct reserveren.',
    keywords: 'airport taxi utrecht, taxi utrecht schiphol, taxi utrecht eindhoven airport, taxi utrecht rotterdam airport, luchthaven taxi utrecht',
    canonical: 'https://www.utrechtairporttaxi.nl/'
  });

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <USPBlock />
      <PriceCalculator />
      <PopularRoutes />
      <WhyChooseUs />
      <BookingCTA />
      <SEOContent />
      <Footer />
    </div>
  );
}
